import { handleShortDate } from '@/utils/handleDate.js'
import SvgIcon from '@/components/SvgIcon'
import PageSizeChanger from '@/components/PageSizeChanger.vue'

//清单的mixin
export const listMixin = {
    components: { SvgIcon,PageSizeChanger },
    model:{
        prop:'childThis',
        event:'setChildThis'
    },
    data(){
        return{
            tableData:[],//当前页数据
            selectData:[],//总勾选的数据
            pageSelectData:[],//当前页勾选的数据
            BillNo:'',//过滤条件
            ProgId:'',
            pageIndex:0,
            tableLoading:false,
            withTax:true,
            withoutTax:true,
            allCheck: false,//页面是否全勾选
            rangeDate:[],
            startDate:'',
            endDate:'',
            totalCount:0,
            resizeFlag:null,
        }
    },
    computed:{
        pageSize:{
            get(){
                return this.$store.state.pagesize;
            },
        },
        currentPage:{
            get(){
                return this.pageIndex + 1;
            }
        }
    },
    created(){
        this.$emit('setChildThis',this);
        //读取localstorage里的含税状态
        if(localStorage.getItem("iswithtaxRecord")){
            var iswithtaxRecord = JSON.parse(localStorage.getItem("iswithtaxRecord"));
            this.withTax = Boolean(iswithtaxRecord.withTax);
            this.withoutTax = Boolean(iswithtaxRecord.withoutTax);  
        }
        //读取localstorage里的pagesize页面大小
        this.$store.commit("GETPAGESIZE",localStorage.getItem("pagesize")?Number(localStorage.getItem("pagesize")):10);
    },
    beforeRouteLeave(to,from,next){
        //跳转到详情页时，不销毁清单页
        if(to.path == `/Home/${from.name}Detail`){
            from.meta.keepAlive = true;
        }else{
            from.meta.keepAlive = false;
        }
        next();
    },
    watch:{
        withTax:{
            handler:function(newval,oldval){
                this.updateTaxRecord();
            }
        },
        withoutTax:{
            handler:function(newval,oldval){
                this.updateTaxRecord();
            }
        },
    },
    methods:{
        /**
         * 更新含税状态 保存在localstorage里
         */
        updateTaxRecord(){
            const taxlist = {withTax:this.withTax,withoutTax:this.withoutTax};
            localStorage.setItem("iswithtaxRecord",JSON.stringify(taxlist));
        },
        /**
         * 将当前勾选的行项加入或者移除总勾选的数组里
         * @param {Array} pageSelectData 当前页面勾选的数据
         * @param {Array} selectData 总勾选的数据
         * @param {boolean} isAdd 添加或删除
         * @returns {Array} 处理后的新数组
         */
        addOrRemoveInSelectData(pageSelectData,selectData,isAdd){
            const result = [...selectData];
            //创建映射表，提高效率
            const PageSelectMap = new Map();
            for(const item of pageSelectData){
                PageSelectMap.set(item.rowkey,true);
            }
            const AllSelectMap = new Map();
            for(const item of selectData){
                AllSelectMap.set(item.rowkey,true);
            }
            //加入逻辑
            if(isAdd){
                for(const row in pageSelectData){
                    if(!AllSelectMap.has(row.rowkey)){
                        result.push(row);
                    }
                }
            }
            //删除逻辑
            else{
                for(const i=result.length-1;i>=0;i--){
                    if(PageSelectMap.has(selectData[i].rowkey)){
                        result.splice(i,1);
                    }
                }
            }
            return result;

        },
        /**
         * 当控件为range的el-date-picker时，可以用这个将该组件的Date类型转成字符串的值 类似20250101
         */
        getTime() {
            if(this.rangeDate){
            this.startDate = handleShortDate(this.rangeDate[0], "From");
            this.endDate = handleShortDate(this.rangeDate[1], "To");
            }
            else{
            this.startDate = "";
            this.endDate = "";
            }
        },
        /**
         * 页面随窗体弹性大小
         * @param {number} height 要减去的上下高度，剩下的就是router-view的高度了 
         */
        frameOnResize(height){
            let that = this;
            window.onresize = () => {
              if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
              }
              that.resizeFlag = setTimeout(() => {
                that.tableHeight = window.innerHeight - height;
                that.resizeFlag = null;
              }, 100);
            }
        },
        /**
         * 重置listmixin里自带的基本条件
         */
        baseReset(){
            this.BillNo = "";
            this.tableData = [];
            this.selectData = [];
            this.pageSelectData = [];
            this.pageIndex = 0;
            this.allCheck = false;
            this.rangeDate = [];
            this.startDate = "";
            this.endDate = "";
            this.totalCount = 0;
        }
    }
}

//详情页的mixin
export const detailMixin = {
    components: { SvgIcon },
    model:{
        prop:'childThis',
        event:'setChildThis'
    },
    data(){
        return{
            BillNo:'',
            tableData:[],
            tableLoading:false,
            resizeFlag:null,
            tableHeight:window.innerHeight - 360,
        }
    },
    created(){
        this.$emit('setChildThis',this);
        this.BillNo = this.$route.query.BillNo;
    },
    methods:{
          /**
         * 页面随窗体弹性大小  但是需要获取完数据以后，计算完表头高度再考虑表身高度，
         * 记得限制备注这种文本的最大显示高度，备注上限400字，会直接让表头高度超级高，压缩表身的显示空间
         * @param {number} height 要减去的上下高度，剩下的就是router-view的高度了 
         */
        frameOnResize(height){
            let that = this;
            that.tableHeight = window.innerHeight - height - this.$refs.headContain.offsetHeight;
            if(that.tableHeight<150)that.tableHeight = 150;//保底高度150
            window.onresize = () => {
              if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
              }
              that.resizeFlag = setTimeout(() => {
                that.tableHeight = window.innerHeight - height - this.$refs.headContain.offsetHeight;
                if(that.tableHeight<150)that.tableHeight = 150;
                that.resizeFlag = null;
              }, 100);
            }
        }
    }
}

//全局的mixin
export const defaultMixin ={
    data(){
        return{
            development:process.env.NODE_ENV=="development"?'/dev':''
        }
    }
}